/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-props-no-spreading */
import styles from '@features/categories/components/CategoriesFilterRange/CategoriesFilterRange.styles';
type PropsType = {
  props: any;
  isDragged: boolean;
};
const CategoriesFilterRangeThumb = ({
  props,
  isDragged
}: PropsType) => <div {...props} key={props.key} sx={styles.thumb(props ? props.style : {}, isDragged)} />;
export default CategoriesFilterRangeThumb;